var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-container"},[_c('p',{staticClass:"welcome-text"},[_vm._v("\n    Welcome\n  ")]),_c('h2',{staticClass:"welcome-name"},[_vm._v("\n    "+_vm._s(_vm.orgInfo.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }